import React from 'react';

interface SearchInputProps {
  value?: string;
  onChange?: (...args: any) => void;
  placeholder: string;
  focus?: boolean;
  className?: string;
}

const SearchInput = ({ value, onChange, placeholder, focus, className }: SearchInputProps) => {
  return (
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className={`border border-gray-300 rounded-md p-2 mb-2 ${className}`}
      onFocus={focus ? (() => true) : undefined}
    />
  );
};
export default SearchInput;
